<template>
  <div class="row">
    <div class="col-12" :class="`media-view-${view} relative`">
      <div class="view-switch">
        <font-awesome-icon
          :icon="['fas', 'th']"
          class="cursor switch-icon mr-3"
          :class="view === 'grid' ? 'current' : ''"
          @click="view = 'grid'"
        />
        <font-awesome-icon
          :icon="['fas', 'list']"
          class="cursor switch-icon"
          :class="view === 'list' ? 'current' : ''"
          @click="view = 'list'"
        />
      </div>
      <advanced-filter
        :refs="$refs"
        :select-filters="selectFilters"
        :date-range="true"
        @ready="ready"
      />

      <v-server-table
        v-if="initialised"
        ref="table"
        :columns="columns"
        :options="options"
        url="/job-notes?media_type=image&orderBy=id&sortedBy=desc&with=media;user"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import Vue from "vue";
import entity from "../../mixins/entity";
import format from "../../mixins/format";
import AdvancedFilter from "../../components/common/AdvancedFilter.vue";
import AppRating from "../../components/common/AppRating.vue";
import GalleryImage from "../../components/common/GalleryImage.vue";

Vue.component("AppRating", AppRating);
Vue.component("GalleryImage", GalleryImage);

export default {
  components: {
    AdvancedFilter,
  },
  mixins: [entity, format],

  data: function () {
    return {
      view: "grid",
      initialised: false,

      selectFilters: {
        status: {
          options: this.$store.state.jobs.jobStatuses.map((v) => ({
            label: v,
            value: v,
          })),
        },
        brand: {
          options: [],
        },
        rating: {
          options: Array.from({ length: 5 }, (_, i) => i + 1).map((v) => ({
            label: `${v} Star`,
            value: v,
          })),
        },
      },

      columns: ["file", "job_id", "user_id", "rating", "id"],
      options: {
        advancedFilter: true,
        orderBy: { ascending: false },
        sortable: ["job_id", "user_id", "rating", "id"],
        perPage: 40,
        perPageValues: [40, 80, 200, 400],
        headings: {
          job_id: () => "Job",
          user_id: () => "User",
          id: () => "Created At",
        },
        templates: {
          file: (h, o) =>
            h("gallery-image", {
              props: {
                title: `JOB #${o.job_id}`,
                src: o.media[0].url,
                sourceButton: true,
                group: `media-${o.job_id}`,
                thumbnailSrc: o.media[0].thumbnails[300],
                width: this.view === "list" ? 150 : 200,
                height: this.view === "list" ? 100 : 133,
              },
            }),
          job_id: (h, o) =>
            h("job-object", {
              props: {
                jobNumber: o.job_id,
                entityId: o.job_id,
                openNew: true,
              },
            }),
          user_id: (h, o) =>
            h("user-object", {
              props: {
                entityId: o.user.id,
                name: o.user.name,
              },
            }),
          rating: (h, o) =>
            h("app-rating", {
              props: {
                id: o.id,
                rating: o.rating,
              },
              on: {
                rated: (rating) => this.rateIt(rating, o),
              },
            }),
          id: (h, o) => this.formatDate(o.created_at),
        },
      },
    };
  },

  computed: {
    tableData() {
      if (!this.$refs || !this.$refs.table) {
        return [];
      }

      return this.$refs.table.data;
    },
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      const brands = await this.$store.dispatch("brands/getData");

      brands.forEach((brand) => {
        this.selectFilters.brand.options = this.selectFilters.brand.options.concat({
          label: brand.name,
          value: brand.id,
        });
      });
    },

    ready() {
      this.initialised = true;
    },

    async rateIt(rating, item) {
      await this.$http.put(`/job-notes/${item.id}`, { rating });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.view-switch {
  position: absolute;
  z-index: 2;
  top: 7px;
  right: 105px;

  .switch-icon {
    font-size: 24px;
    color: #858687;
  }

  .switch-icon.current {
    color: #36a9e1;
  }
}

.media-view-grid {
  /deep/ .table {
    display: block;

    thead {
      display: none;
    }

    tbody {
      width: 100%;
    }

    tr {
      display: inline-block;
      width: 12.5%;
    }

    td {
      display: inline-block;
      width: 100%;
      max-width: 100%;
      border: 0;
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }
}

/deep/ .VueTables__no-results {
  width: 100% !important;

  & > td {
    width: 100% !important;
  }
}
</style>
